/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Tab_TranscriptsInputs */



/**
* | output |
* | --- |
* | "Transcripts" |
*
* @param {Preset_Manager_Tab_TranscriptsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_tab_transcripts = /** @type {((inputs?: Preset_Manager_Tab_TranscriptsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Tab_TranscriptsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcriptions")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkripte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стенограммы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("成绩单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcrições")
	return /** @type {LocalizedString} */ ("Transcripts")
});